import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var toolbarKey = new PluginKey('hyperlinkToolbarItems');
export var toolbarButtonsPlugin = function toolbarButtonsPlugin(initialState) {
  return new SafePlugin({
    key: toolbarKey,
    state: {
      init: function init(_, __) {
        return initialState;
      },
      apply: function apply(tr, pluginState) {
        var metaState = tr.getMeta(toolbarKey);
        if (metaState) {
          return metaState;
        }
        return pluginState;
      }
    }
  });
};